import type { ChallengeEvent } from '@xox/shared'
import { useNavigate } from 'react-router'
import { useCountdown } from '../../hooks/useCountdown'
import { GAME_BY_CHALLENGE, ROOM_PATH_FOR } from '../../lib/games'
import { Avatar } from '../Avatar'
import { GameLogo } from '../art/GameLogo'
import { Button } from '../ui'

interface Props {
  ev: ChallengeEvent
  /** Accepted or ignored: the card can go. */
  onDone: () => void
}

/** "Ada challenges you to Connect Four" with Accept (lands you seated) and Ignore. */
export function ChallengeCard({ ev, onDone }: Props) {
  const navigate = useNavigate()
  const remaining = useCountdown(ev.expiresAt, Date.now)
  const game = GAME_BY_CHALLENGE[ev.game]
  if (remaining !== null && remaining <= 0) {
    onDone()
    return null
  }
  const accept = () => {
    onDone()
    navigate(`${ROOM_PATH_FOR[ev.game]}/${ev.code}?seat=1`)
  }
  return (
    <div className="flex items-center gap-3">
      <Avatar id={ev.from.id} avatar={ev.from.avatar} color={ev.from.color} size="md" />
      <div className="min-w-0 flex-1">
        <div className="text-[10px] font-black uppercase tracking-[0.2em] text-sky-600 dark:text-sky-300">
          Challenge · {remaining === null ? '' : `${Math.ceil(remaining / 1000)}s`}
        </div>
        <div className="truncate text-sm font-black leading-tight">
          {ev.from.nickname} wants to play {game.title}
        </div>
      </div>
      <GameLogo game={game.to} className="size-9 shrink-0" compact />
      <div className="flex shrink-0 flex-col gap-1">
        <Button variant="arcade" tone="go" className="min-h-9 px-3 py-1 text-xs" onClick={accept}>
          Accept
        </Button>
        <Button variant="ghost" className="min-h-8 px-3 py-1 text-xs" onClick={onDone}>
          Ignore
        </Button>
      </div>
    </div>
  )
}
